import { useMemo } from 'react';

import type { RootState } from '~/app/rootReducer';
import useDelayedResult from '~/common/hooks/useDelayedResult';
import { BDRequestType } from '~/common/models/apis/apiResponse.model';
import type { OrganizationItem } from '~/common/models/organization.model';
import { getOperationStatus } from '~/common/utils/store/selector.helper';

import { selectOrgListById } from '../organizationsSlice';

/**
 * Custom hook to get organization details by ID
 * @param organizationId - The ID of the organization to fetch
 * @returns The organization details or undefined if not found/loading
 */
export const useGetOrganizationById = (organizationId: string) => {
  const selectOrgDetailsById = useMemo(
    () => (state: RootState) => {
      return selectOrgListById(state, organizationId) as OrganizationItem;
    },
    [organizationId]
  );

  const selectOrgByIdOperation = useMemo(
    () => (state: RootState) =>
      getOperationStatus(state.organizations, BDRequestType.GET_BY_ID),
    []
  );

  const {
    result: orgDetails,
    isLoading,
    isFailed,
  } = useDelayedResult(selectOrgDetailsById, selectOrgByIdOperation);

  return { orgDetails, isLoading, isFailed };
};
